<template>
    <v-dialog
        :fullscreen="fullscreen"
        persistent
        :max-width="largura"
        v-model="exibirModal"
        :no-click-animation="true"
        scrollable
        @keydown.esc="fecharModal"
        :transition="transition">
        <template v-slot:activator="{on}" v-if="this.$slots.botaoAbrirModal">
          <div>
            <slot name="botaoAbrirModal"/>
          </div>

        </template>
        <v-card width="100%" :style="styleContent">
            <v-toolbar class="toolbar toolbar-modal" dark :color="corToolbar" v-if="!this.$slots.toolbar">
                <v-toolbar-title class="text-subtitle-2 primary white text font-weight-bold pt-2 pb-1">
                    <span v-if="!this.$slots.modalTitulo">{{titulo}}</span>
                    <slot name="modalTitulo"/>
                </v-toolbar-title>
                <v-spacer/>
                  <az-auto-save v-if="mostrarSalvamentoAutomatico" class="auto-save-modal"/>
                    <v-btn class="close__button" icon @click="fecharModal">
                        <v-icon :size="tamanhoIconeBotaoFechar">close</v-icon>
                    </v-btn>
            </v-toolbar>

            <slot name="toolbar"/>

            <slot name="conteudo"/>

            <v-divider v-if="this.$slots.acoes || this.$slots.botoesEsquerdo || this.$slots.botoesDireito"/>
            <slot name="acoes"/>
            <acoes-formulario v-if="!this.$slots.acoes && !esconderAcoes">
                <template v-slot:esquerdo>
                    <slot  name="botoesEsquerdo"/>
                </template>
                <template v-slot:direito>
                    <slot  name="botoesDireito"/>
                </template>
            </acoes-formulario>
        </v-card>
    </v-dialog>
</template>


<script>
    import AcoesFormulario from '@/views/components/acoes/AcoesFormulario'
    export default {
        components: { AcoesFormulario },
        name: 'Modal',
        props:{
            exibir: {
                type: Boolean,
                default: true
            },
            largura: {
                type: [String, Number],
                default:'1100'
            },
            mostrarSalvamentoAutomatico: {
                type:Boolean,
                default:false
            },
            titulo: {
                type:String,
                required: true
            },
            corToolbar: {
                type:String,
                default:'primary'
            },
            styleContent: {
                type: Object,
                default: () => {}
            },
            fullscreen: {
                type: Boolean,
                default: false
            },
            transition: {
                type: String,
                defalt: ''
            },
            tamanhoIconeBotaoFechar: {
                type: String,
                default: '20'
            },
            esconderAcoes: {
                type: Boolean,
                default: false
            },
            mostrarScroll: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                exibirModal: true
            }
        },
        mounted() {
            this.esconderScroll()
        },
        beforeDestroy() {
            this.exibirScroll()
        },
        watch: {
            exibir: {
                handler(val) {
                    this.exibirModal = val
                },
                immediate: true
            }
        },
        methods: {
            exibirScroll() {
                if (this.fullscreen && !this.mostrarScroll) document.documentElement.style.overflow = 'visible'
            },
            esconderScroll() {
                if (this.fullscreen && !this.mostrarScroll) document.documentElement.style.overflow = 'hidden'
            },
            fecharModal() {
                this.exibirModal = false
                this.$emit('fecharModal')
            }
        }
    }

</script>

<style scoped lang="stylus">
    .auto-save-modal
        color white !important

    .toolbar
        flex: 0 !important
</style>

<style lang="stylus">
    .toolbar-modal .v-toolbar__content
        height auto !important
</style>
